import { render, staticRenderFns } from "./torbrek.vue?vue&type=template&id=4d4557f1&scoped=true"
import script from "./torbrek.vue?vue&type=script&lang=js"
export * from "./torbrek.vue?vue&type=script&lang=js"
import style0 from "./torbrek.vue?vue&type=style&index=0&id=4d4557f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4557f1",
  null
  
)

export default component.exports